import {
    request
} from "./request";

export function getAllCancerGeneCensus() {
    return request({
        url: '/ascancer/api/cgc',
    })
}

export function getAllGeneIdFromIsoformSpecificPPI() {
    return request({
        url: '/ascancer/api/isoformppi/allgeneid',
    })
}

export function getAllTranscriptIdFromIsoformSpecificPPI() {
    return request({
        url: '/ascancer/api/isoformppi/alltxid',
    })
}

// find all transcript_id by gene_id
export function getAllTranscriptIdByGeneId(geneid) {
    return request({
        url: '/ascancer/api/isoformppi/findtxbygene',
        params: {
            geneid
        }
    })
}

// find gene_id by transcript_id
export function getGeneIdByTranscriptId(txid) {
    return request({
        url: '/ascancer/api/isoformppi/findgenebytx',
        params: {
            txid
        }
    })
}

export function getIsoformSpecificPPIByTranscriptId(txid) {
    return request({
        url: '/ascancer/api/isoformppi/bytx',
        params: {
            txid
        }
    })
}